"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationPositions = exports.NotificationVariants = void 0;
var react_1 = __importDefault(require("react"));
var NotificationVariants;
(function (NotificationVariants) {
    NotificationVariants["ERROR"] = "error";
    NotificationVariants["SUCCESS"] = "success";
    NotificationVariants["DEFAULT"] = "default";
})(NotificationVariants = exports.NotificationVariants || (exports.NotificationVariants = {}));
var NotificationPositions;
(function (NotificationPositions) {
    NotificationPositions[NotificationPositions["TOP"] = 0] = "TOP";
    NotificationPositions[NotificationPositions["BOTTOM"] = 1] = "BOTTOM";
})(NotificationPositions = exports.NotificationPositions || (exports.NotificationPositions = {}));
var Notification = function (_a) {
    var message = _a.message, visible = _a.visible, position = _a.position;
    return (react_1.default.createElement("div", { className: "notification", "data-position": position === NotificationPositions.TOP ? 'top' : 'bottom', "data-visible": visible },
        react_1.default.createElement("p", null, message)));
};
exports.default = Notification;
